import React, { useState, useEffect, useRef } from 'react';
import Modal                            from 'react-bootstrap/Modal';
import CloseBtn                         from 'assets/icons/Close.svg';
import ViewIcon                         from 'assets/icons/View.svg';
import DownloadIcon                     from 'assets/icons/Download.svg';
import FileIcon                         from 'assets/icons/Uploaded File.svg';
import ArrowDown                        from 'assets/icons/Arrow Down.svg';
import PlusCircle                       from 'assets/icons/Plus Circle.svg';
import CancelIcon                       from 'assets/icons/Cancel Icon.svg';
import { nricOrPassport, standardDate } from 'helpers/common.helper';
import AuthService                      from 'services/auth.service';
import GuaranteeLetterService           from 'services/guarantee-letter.service';
import { GuaranteeLetterEdit }       from './GuaranteeLetterEdit';

export function GuaranteeLetterDetails(props) {
  const [show, setShow]           = useState(false);
  const [details, setDetails]     = useState(props.data);
  const [editProps, setEditProps] = useState({});

  const handleShow  = () => {
    setShow(true);

    GuaranteeLetterService.show(props.data.id).then(
      (data) => {
        setDetails(data.guarantee_letter);
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  const handleClose   = () => {
    setShow(false);
    setShowActions(false);
  };

  // Regular Information
    const dateRefClaim = (details, status, color) => {
      const dRCList = [
        { title: 'Date Received', value: standardDate(details.request_date) },
        { title: 'Reference No.', value: details.reference_no },
        { title: 'GL Request Status', value: status }
      ]

      return dRCList.map((hash, index) => {
        const padding   = ['pr-1', 'px-1', 'pl-1'][index];
        const textColor = index === 2 ? ' text-' + color : '';

        return (
          <div className={ "col " + padding } key={ index }>
            <div className="date-ref-claim-box p-4 text-center h-100">
              <p className="text-lightgrey mb-0 font-size-3">{ hash.title }</p>
              <p className={ "mb-0" + textColor }><b>{ hash.value }</b></p>
            </div>
          </div>
        )
      });
    }

    const [infoSection, setInfoSection]   = useState(props.data);
    const [attachments, setAttachments]   = useState(<span></span>);
    const [invoiceBills, setInvoiceBills] = useState(<span></span>);

    useEffect(() => {
      const patientInfo = [
        { title: 'Patient IC/Passport No.', value: nricOrPassport(details.claimant.nric) },
        { title: 'Full Name',               value: [details.claimant.first_name, details.claimant.last_name].filter(e => e).join(' ') },
        { title: 'Email',                   value: details.claimant.email },
        { title: 'Phone',                   value: details.claimant.phone },
        { title: 'Clinic/Hospital',         value: details.panel_name },
        { title: 'Company Name',            value: details.company_name },
        { title: 'Insurer',                 value: details.insurance?.name },
        { title: 'Document Type',           value: props.doctype }
      ]

      setEditProps({
        id:         details.id,
        nric:       nricOrPassport(details.claimant.nric),
        name:       [details.claimant.first_name, details.claimant.last_name].filter(e => e).join(' '),
        email:      details.claimant.email,
        phone:      details.claimant.phone,
        insurer_id: details.insurance?.id,
        insurer:    details.insurance?.name,
        doctype:    details.document_type,
        notes:      details.notes,
        documents:  details?.doctor_upload_documents
      });

      const byChunks = patientInfo.reduce((memo, value, index) => {
        if (index % 2 === 0 && index !== 0) memo.push([])
        memo[memo.length - 1].push(value)
        return memo
      }, [[]]);

      const displayedInfo = byChunks.map((array, index) => {
        return (
          <div className="row" key={ index }>
            <div className="col">
              <p className="text-lightgrey mb-0 font-size-3">{ array[0]?.title }</p>
              <p><b>{ array[0]?.value || '-'  }</b></p>
            </div>

            <div className="col">
              <p className="text-lightgrey mb-0 font-size-3">{ array[1]?.title }</p>
              <p><b>{ array[1] ? (array[1]?.value || '-') : null }</b></p>
            </div>
          </div>
        )
      });

      setInfoSection(displayedInfo);
      const filesWithUrls     = details.doctor_upload_documents.filter((hash) => !!hash.url);
      const invoicesWithUrls  = details.invoice_bill_documents.filter((hash) => !!hash.url);

      if (filesWithUrls.length > 0) {
        const uploads = filesWithUrls.map((file, index) => {
          return (
            <span key={ index }>
              <a href={ file?.url } target="_blank" rel="noreferrer" className="text-danger">
                <p className="font-size-4">
                  <img src={ FileIcon } alt="view-letter" className="clickable mr-4" />
                    { file.url.replace(/^.+\/documents\//, '') }
                </p>
              </a>
            </span>
          )
        });

        setAttachments(<div>
          <p className="text-lightgrey mb-2 font-size-3">Uploaded File</p>
          { uploads }
        </div>);
      }

      if (invoicesWithUrls.length > 0) {
        const uploads = invoicesWithUrls.map((file, index) => {
          return (
            <span key={ index }>
              <a href={ file?.url } target="_blank" rel="noreferrer" className="text-danger">
                <p className="font-size-4">
                  <img src={ FileIcon } alt="view-letter" className="clickable mr-4" />
                    { file.url.replace(/^.+\/documents\//, '') }
                </p>
              </a>
            </span>
          )
        });

        setInvoiceBills(<div>
          <p className="text-lightgrey mb-2 font-size-3">Uploaded Invoice Bill & Claim Form</p>
          { uploads }
        </div>);
      }
    }, [details]); // eslint-disable-line react-hooks/exhaustive-deps

  // Delete function
    const [showActions, setShowActions] = useState(false);

    const modalClick = (target) => {
      if (target.id !== 'more-actions-btn' && target.id !== 'arrow-down-icon') {
        setShowActions(false);
      }
    }

    const confirmDelete = (target) => {
      const confirmed = window.confirm('You are about to delete this guarantee letter. Confirm?');

      if (confirmed) {
        GuaranteeLetterService.deleteGuaranteeLetter(details.id).then(
          (data) => {
            props.triggerReload();
            setShow(false);
            alert('Guarantee Letter Ref No. ' + details.reference_no + ' was deleted.');
          },
          (error) => {
            console.log(error.response);

            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }
          }
        );
      }
    }

  // More Actions
    const allowDelete   = ['Opened', 'Pending'].includes(props.status);
    const hasDownload   = !!details.guarantee_letter

  // Submit action.
    const [finalGL, setFinalGL]                 = useState(['Initial GL'].includes(props.status));
    const [errorResponse, setErrorResponse]     = useState('');
    const [successResponse, setSuccessResponse] = useState('');
    const refreshGuaranteeLetters               = () => props.triggerReload();
    const [submitBtn, setSubmitBtn]             = useState(<button>Submit</button>);
    const [attachedFile, setAttachedFile]       = useState([]);
    const [disabledSubmit, setDisabledSubmit]   = useState(false);

    useEffect(() => {
      const handleSubmit = () => {
        if (attachedFile.length === 0) {
          setErrorResponse('Please attach both invoice bill & claim form before submitting.');
          return;
        }

        const formData = new FormData();

        if (attachedFile.length > 0) {
          attachedFile.forEach(function(file) {
            formData.append('guarantee_letter[invoice_bill_documents_attributes][][file]', file, file.name);
          });
        }

        setDisabledSubmit(true);

        GuaranteeLetterService.requestFinal(props.data.id, formData).then(
          (data) => {
            setSuccessResponse('Invoice bill uploaded');

            setTimeout(function() {
              refreshGuaranteeLetters();
              handleClose();
              setFinalGL(false);
            }, 1500);
          },
          (error) => {
            console.log(error.response);

            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }
          }
        );

        setTimeout(() => { setDisabledSubmit(false) }, 4000); // Needs to be slightly longer than the closing actions.
      }

      setSubmitBtn(
        <div className="text-center mt-6 conditional-display" displayed={ (attachedFile.length !== 0).toString() }>
          <button className="btn btn-danger text-white rounded-pill py-3 px-20" onClick={() => { handleSubmit() }} disabled={ disabledSubmit } >
            Submit
          </button>
        </div>
      );
    }, [attachedFile, disabledSubmit]); // eslint-disable-line react-hooks/exhaustive-deps

  // Upload Invoice Bill
    const hiddenFileInput                 = useRef();
    const [fileInputs, setFileInputs]     = useState(<span></span>);

    const handleFileClick = (event) => {
      hiddenFileInput.current.click();
    };

    const checkFileFormat = (file) => {
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      setErrorResponse('');

      if (!file) { return }

      if (!allowedTypes.includes(file.type)) {
        setErrorResponse('File type can only be JPEG, JPG, PNG or PDF');
      } else if (file.size > 4000000) {
        setErrorResponse('File size exceeds 4MB');
      } else {
        let allFiles    = attachedFile.slice();
        allFiles.push(file);
        setAttachedFile(allFiles);
      }
    };

    useEffect(() => {
      const removeFileSection = (e, index) => {
        let allFiles    = attachedFile.slice();
        allFiles.splice(index, 1);
        setAttachedFile(allFiles);
      };

      const fileInputFields = attachedFile.map((file, index) => {
        return (
          <div className="file-input-field-section" key={ index }>
            <p className="font-size-4 mt-2 text-danger">
              <img src={ FileIcon } alt="file-icon" className="mr-4" />
              { file.name }
              <img src={ CancelIcon } alt="remove-attachment" className="clickable ml-4 w-em-5" onClick={(e) => removeFileSection(e, index) } />
            </p>
          </div>
        )
      });

      setFileInputs(
        <div className="font-size-6 flex-grow-1 pt-3">
          { fileInputFields }
          <input type="file" onChange={(e) => checkFileFormat(e.target.files[0]) } value="" className="d-none" ref={ hiddenFileInput } />
          <img src={ PlusCircle } className="clickable w-em-8 pb-2" alt="add-invoice-bill" onClick={ handleFileClick } />
        </div>
      );
    }, [attachedFile]); // eslint-disable-line react-hooks/exhaustive-deps

  // Refresh everything after edited.
    const refreshListAndDetails = () => {
      refreshGuaranteeLetters();

      GuaranteeLetterService.show(props.data.id).then(
        (data) => {
          setDetails(data.guarantee_letter);
        },
        (error) => {
          console.log(error.response);

          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }

  return (
    <div>
      <img src={ ViewIcon } alt="view-letter" className="clickable mr-4 view-gl-icon" onClick={ handleShow } />

      { hasDownload && (
        <a href={ details.guarantee_letter } target="_blank" rel="noreferrer">
          <img src={ DownloadIcon } alt="download-letter" className="clickable mr-4 d-none d-lg-inline-block"/>
        </a>
      )}

      <Modal show={ show } onHide={ handleClose } keyboard={ false } dialogClassName="modal-70w" centered onClick={(e) => modalClick(e.target) }>
        <Modal.Header>
          <Modal.Title>GL Details</Modal.Title>

          <span className="float-right position-relative font-size-4 conditional-display" displayed={ (allowDelete || hasDownload).toString() }>
            <button id="more-actions-btn" className="btn btn-outline-danger rounded-pill px-4 py-2" onClick={() => setShowActions(!showActions) }>
              More Actions
              <img id="arrow-down-icon" src={ ArrowDown } alt="arrow-down" className="ml-3" />
            </button>

            <div id="claim-more-actions" className="conditional-display" displayed={ showActions.toString() }>
              { props.status === 'Pending' && (
                <GuaranteeLetterEdit details={ editProps } handleReload={ refreshListAndDetails } />
              )}

              { allowDelete && (
                <div className="action-child px-4 py-4" onClick={() => confirmDelete() }>Delete</div>
              )}

              { hasDownload && (
                <a href={ details.guarantee_letter } target="_blank" rel="noreferrer">
                  <div className="action-child px-4 py-4 text-titleblack">Download GL</div>
                </a>
              )}
            </div>
          </span>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <div className="row mb-6">
              { dateRefClaim(details, props.status, props.color) }
            </div>

            <p className="font-size-7"><b>Patient Info</b></p>
            { infoSection }

            <p className="text-lightgrey mb-0 font-size-3">Remarks</p>
            <p><b className="multiline-text">{ details.notes || '-' }</b></p>

            { attachments }
            { invoiceBills }

            { finalGL &&
              <div>
                <div className="border border-black text-center pt-9 pb-4" style={{ borderRadius: '0.5em' }}>
                  <h5>Upload Invoice Bill & Claim Form</h5>
                  <p className="font-size-4">File can be in either JPEG, JPG, PNG or PDF formats. Size limit is 4MB.</p>
                  { fileInputs }
                  <p className="text-danger pb-2 mb-0">{ errorResponse }</p>
                </div>

                <p className="text-success text-center pb-2 mt-8 mb-0">{ successResponse }</p>
                { submitBtn }
              </div> }
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}